import script from "./resource-properties-edit-component.vue?vue&type=script&setup=true&lang=ts"
export * from "./resource-properties-edit-component.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__